import base from '@/services/authorization/index';
export default Object.assign({}, base);
